// Module
var code = `<div class="candidate-profile-campaign-status" ng-if="candidateCampaignStatus.campaignStatus"> <div class="candidate-profile-campaign-status--icon" uib-tooltip="{{candidateCampaignStatus.autoContactRequestTooltip}}" tooltip-placement="bottom"> {{candidateCampaignStatus.submissionLabel}} </div> </div>`;
// Exports
export default code;